import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordFormGroup: FormGroup;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.forgotPasswordFormGroup = this.formBuilder.group({
      'email' : [null, Validators.required]
    });

  }

  switchLanguage(language: string) {
    this.translate.use(language);
  }

  getLanguage() {
    return this.translate.currentLang;
  }


  onSubmit() {
    const authData = {
      email: this.forgotPasswordFormGroup.value.email
    };
    this.authService.forgotPassword(authData).subscribe(data => {
      console.log(data);
    });
  }
}
